import React, { useEffect, useState } from 'react';
import { Button, Header, Icon, Image, Placeholder } from 'react-frontier';
import { useUser } from '../Hooks';
import { useTranslation } from 'react-i18next';
import { bindClose } from '@payfront/components/Util';
import API, { CDN_URL } from '../API';
import classNames from 'classnames';

interface ClientListProps{
	// onClientChange: (client_id: number)=>void,
}

interface UserClient{
	client_id: number,
	client_name: string,
	website: string,
}

var ClientItem = (props: { placeholder?: boolean, client?: UserClient, admin?: boolean, onClick?: ()=>void })=>{
	var [logoFailed, setLogoFailed] = useState<boolean>(null);

	if(props.placeholder){
		return <div className="client placeholder">
			<div className="logo placeholder"></div>
			<div className="info">
				<div className="name">
					<Placeholder width={120} />
				</div>
				<div className="meta">
					<Placeholder width={80} />
				</div>
			</div>
		</div>
	}

	if(!props.client) return null;

	return <div className={classNames('client', {
		admin: props.admin
	})} onClick={props.onClick}>
		<div className={classNames("logo", { placeholder: logoFailed })}>
			<Image src={`${CDN_URL}/clients/${props.client.client_id}.webp`} hideOnFail onFallback={bindClose(setLogoFailed, true)} />
		</div>
		<div className="info">
			<div className="name">{props.client.client_name}</div>
			{props.client.website ? (
				<div className="meta">{props.client.website.replace(/https?:\/\//gi, '')}</div>
			) : (
				<div className="meta">
					<i>Sin página web</i>
				</div>
			)}
		</div>
		<div className="icon">
			<Icon name='arrow-right' />
		</div>
	</div>
}

var ClientList = (props: ClientListProps)=>{
	var { t } = useTranslation();
	var { user, setActiveClient } = useUser();
	var [loadError, setLoadError] = useState<string>(null);
	var [clients, setClients] = useState<UserClient[]>(null);

	useEffect(()=>{
		API.getUserClients().then(res=>{
			if(res.error) return setLoadError(res.message);
			setClients(res.data);
		}).catch(err=>{
			return setLoadError(t('common.unexpected_error', { code: 'CLST-1' }));
		})
	}, []);

	var changeClient = (client_id: number)=>{
		return ()=>{
			setActiveClient(client_id);
		}
	}

	return <div className="pf client-list-screen">
		<div className="logo">
			<img src={`${CDN_URL}/logo/LogoH.webp`} />
		</div>
		<div className="user">
			<Icon name='user-circle' />
			<div className="info">
				<div className="name">Hola, {user.first_name}</div>
				<Button size='tiny' text='Mi cuenta' iconName={'pen'} basic />
			</div>
			<Button text='Cerrar sesión' size='tiny' onClick={API.logout} />
		</div>
		<div className="clients">
			{user.admin && (
				<ClientItem admin onClick={changeClient(-1)} client={{
					client_id: -1,
					client_name: 'Payfront Admin',
					website: 'payfront.mx'
				}} />
			)}
			{clients ? (
				clients.length==0 ? (
					<div className="pf container">
						<Header text={'Sin clientes'} subtext={'No tienes acceso a ningún cliente en Payfront'} />
					</div>	
				) : clients.map(a=>(
					<ClientItem onClick={changeClient(a.client_id)} client={a} key={`CLT-${a.client_id}`} />
				))
			) : loadError ? (
				<div className="pf container">
					<Header text={'Error'} subtext={loadError} />
				</div>
			) : (
				new Array(3).fill('A').map((a, i)=>(
					<ClientItem placeholder key={`CLTP-${i}`} />
				))
			)}
		</div>
	</div>
}

export default ClientList;